// ============================================================
//  src/admin/components/UI.js
//  Small shared presentational primitives used across admin
//  pages: StatCard, PageHeader, Badge, Pagination.
// ============================================================
import React from 'react';
import { Link } from 'react-router-dom';

// DB tinyint/boolean flags can come back as JS number (1/0), string ('1'/'0'),
// or real boolean depending on the PDO driver — a plain `if (x)` or `!!x`
// treats the string "0" as truthy. Use this instead of raw truthiness
// anywhere a value came straight from the API.
export function isFlagTrue(v) {
  return v === true || v === 1 || v === '1';
}

export function StatCard({ label, value, sub, accent }) {
  return (
    <div className="bf-stat-card">
      <div className="bf-stat-label">{label}</div>
      <div className="bf-stat-value" style={accent ? { color: accent } : undefined}>{value}</div>
      {sub && <div className="bf-stat-sub">{sub}</div>}
    </div>
  );
}

export function PageHeader({ title, subtitle, actions, backTo, backLabel }) {
  return (
    <div>
      {backTo && (
        <Link to={backTo} className="bf-back-link">
          ← {backLabel || 'Back'}
        </Link>
      )}
      <div className="bf-page-header">
        <div>
          <h1 className="bf-page-title">{title}</h1>
          {subtitle && <div className="bf-page-subtitle">{subtitle}</div>}
        </div>
        {actions && <div className="bf-flex-wrap">{actions}</div>}
      </div>
    </div>
  );
}

const TONE_CLASS = {
  success: 'bf-badge-success',
  danger: 'bf-badge-danger',
  warning: 'bf-badge-warning',
  muted: 'bf-badge-muted',
  primary: 'bf-badge-primary',
};

export function Badge({ tone = 'muted', children }) {
  return <span className={`bf-badge ${TONE_CLASS[tone] || TONE_CLASS.muted}`}>{children}</span>;
}

export function Pagination({ page, totalPages, onChange, total, limit }) {
  if (totalPages <= 1) return null;
  const start = total === 0 ? 0 : (page - 1) * limit + 1;
  const end = Math.min(total, page * limit);
  return (
    <div className="bf-pagination">
      <button className="btn btn-outline bf-btn-sm" disabled={page <= 1} onClick={() => onChange(page - 1)}>← Prev</button>
      <span className="bf-pagination-info">
        {total != null ? `${start}–${end} of ${total}` : `Page ${page} of ${totalPages}`}
      </span>
      <button className="btn btn-outline bf-btn-sm" disabled={page >= totalPages} onClick={() => onChange(page + 1)}>Next →</button>
    </div>
  );
}